const actions = {

  NOTIFICATIONS_READ_BEGIN: 'NOTIFICATIONS_READ_BEGIN',
  NOTIFICATIONS_READ_SUCCESS: 'NOTIFICATIONS_READ_SUCCESS',
  NOTIFICATIONS_READ_ERR: 'NOTIFICATIONS_READ_ERR',
  
  NOTIFICATIONS_DELETE_BEGIN: 'NOTIFICATIONS_DELETE_BEGIN',
  NOTIFICATIONS_DELETE_SUCCESS: 'NOTIFICATIONS_DELETE_SUCCESS',
  NOTIFICATIONS_DELETE_ERR: 'NOTIFICATIONS_DELETE_ERR',

  notificationsReadBegin: () => {
    return {
      type: actions.NOTIFICATIONS_READ_BEGIN,
    };
  },

  notificationsReadSuccess: (data) => {
    return {
      type: actions.NOTIFICATIONS_READ_SUCCESS,
      data,
    };
  },

  notificationsReadErr: (err) => {
    return {
      type: actions.NOTIFICATIONS_READ_ERR,
      err,
    };
  },

  notificationsDeleteBegin: () => {
    return {
      type: actions.NOTIFICATIONS_DELETE_BEGIN,
    };
  },

  notificationsDeleteSuccess: (data) => {
    return {
      type: actions.NOTIFICATIONS_DELETE_SUCCESS,
      data,
    };
  },

  notificationsDeleteErr: (err) => {
    return {
      type: actions.NOTIFICATIONS_DELETE_ERR,
      err,
    };
  },
      
};

export default actions;
